// extracted by mini-css-extract-plugin
export var bubble = "_2t-0";
export var container = "_2t-f";
export var contrastBorder = "_2t-g";
export var greyOut = "_2t-2";
export var initialsColor0 = "_2t-3";
export var initialsColor1 = "_2t-4";
export var initialsColor10 = "_2t-d";
export var initialsColor11 = "_2t-e";
export var initialsColor2 = "_2t-5";
export var initialsColor3 = "_2t-6";
export var initialsColor4 = "_2t-7";
export var initialsColor5 = "_2t-8";
export var initialsColor6 = "_2t-9";
export var initialsColor7 = "_2t-a";
export var initialsColor8 = "_2t-b";
export var initialsColor9 = "_2t-c";
export var initialsWrapper = "_2t-1";
export var large = "_2t-l";
export var medium = "_2t-k";
export var mediumSmall = "_2t-j";
export var mediumSmallMedium = "_2t-o";
export var micro = "_2t-h";
export var small = "_2t-i";
export var tiny = "_2t-n";
export var xTiny = "_2t-m";